export default __webpack_public_path__ + "422ebdf2855c8ca36f26eaa1f34284c2.svg";